import type { LayoutPageConfig } from './types';

export const homePageConfig = {
  namespacesRequired: ['home', 'dataEnrichment'],
  layout: {
    showHeader: false,
  },
} satisfies LayoutPageConfig;
